import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { auth } from '../../config/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { setLocation } from '../../store/slices/authSlice';

const ProtectedHomeRoute = ({ children }) => {
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth);
    const locationState = useSelector(state => state.location); // Nouveau : récupérer depuis locationSlice
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const hasAuthLocation = authState.location?.coordinates?.length > 0;
    const hasSliceLocation = locationState.location?.coordinates?.length > 0;

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (authState.uid && !hasAuthLocation && hasSliceLocation) {
            dispatch(setLocation({
                type: 'Point',
                coordinates: locationState.location.coordinates,
                geoHash: locationState.location.geoHash || ''
            }));
        }
    }, [authState.uid, dispatch, hasAuthLocation, hasSliceLocation, locationState.location]);

    if (loading) {
        return null;
    }

    // Si pas authentifié, rediriger vers Home
    if (!currentUser || !authState.uid) {
        return <Navigate to="/" replace />;
    }

    // Vérifier la progression du profil et rediriger en conséquence
    const getRedirectPath = () => {
        if (!authState.name || !authState.doB) {
            return '/auth/first-name';
        }
        if (!authState.gender) {
            return '/auth/your-gender';
        }
        if (!authState.genderSearch) {
            return '/auth/interested';
        }
        if (!authState.LookingFor) {
            return '/auth/looking-for';
        }
        if (!authState.photos || authState.photos.length < 2) {
            return '/auth/recent-pics';
        }
        // Vérifier la localisation depuis le nouveau locationSlice
        if (!hasAuthLocation && !hasSliceLocation) {
            return '/auth/location';
        }
        return null;
    };

    const redirectPath = getRedirectPath();
    if (redirectPath) {
        return <Navigate to={redirectPath} replace />;
    }

    return children;
};

export default ProtectedHomeRoute;
